import { Button } from '@stitch-fix/mode-react';
import { useClientAuth } from '@stitch-fix/sf-next';
import { ImageHalfScreenHero } from '../../ImageHalfScreenHero';
import { useAuthGatedCallback } from '../../../hooks/useAuthGatedCallback';

export const LandingHeroModule = (props: {
  content: {
    description: string;
    headline: string;
    image: { altText: string; baseUrl: string; mediaPath: string };
  };
  ctas: { actionType: string; text: string }[];
  openBuyWizard: () => void;
  openRedeemWizard: () => void;
  isMobile: boolean;
}) => {
  const { content, ctas, openBuyWizard, openRedeemWizard, isMobile } = props;
  const { headline, description, image } = content;
  const { altText, baseUrl, mediaPath } = image;

  const { authStatus } = useClientAuth();

  const gatedOpenRedeemWizard = useAuthGatedCallback(openRedeemWizard);

  return (
    <ImageHalfScreenHero
      title={headline?.toUpperCase()}
      image={{
        src: `${baseUrl}q_auto:best${mediaPath}`,
        alt: altText,
        aspectRatio: { height: 960, width: 1440 },
      }}
      description={description}
      variant="gray"
      CtaButton={
        <Button variant="filled-statement" onClick={openBuyWizard}>
          {ctas[0].text}
        </Button>
      }
      CtaSecondaryButton={
        <Button
          variant="outline"
          disabled={authStatus === 'loading'}
          onClick={gatedOpenRedeemWizard}
        >
          {ctas[1].text}
        </Button>
      }
      contentOrder={isMobile ? 'mediaFirst' : 'textFirst'}
    />
  );
};
